export default __webpack_public_path__ + "318cfdf58337a8ccc2dafe15e2afbc74.png";